module.exports = __webpack_public_path__ + "img/symbol_1.918cd9dd.png";